<template>
    <nav v-if="isDesktop.screenSize.value === 'xs' && type!='notificationTab' || isDesktop.screenSize.value === 'sm' &&  type!='AccountListTab' && type!='notificationTab'" class="w-full pt-8 pb-4 flex items-center justify-around xs:justify-between" :class="wrapperClass">
        <button
            type="button"
            v-for="tab in tabs"
            :ref="tab.value"
            :key="tab.title"
            :class="[
                tab.value === currentTab && tabActiveClass
                    ? tabActiveClass
                    : '',
                tabClass,
            ]"
            :disabled="tab.disabled || false"
            @click="handleClick(tab.value)"
        >
            <div class="flex flex-col items-center justify-center pt-3 pb-[10px] h-10 xs:py-0" :class="[tabButtonClass]">
                <div v-if="tab.icon">
                    <fa :class="[tab.value === currentTab ? 'text-black-600' : 'text-gray-500', iconSize ? iconSize : 'w-4 h-6']" :icon="['fal', tab.icon]" class="xs:align-top"></fa>
                </div>
                <div v-if="tab.count > 0">
                    {{ tab.title + ' (' + tab.count + ')' }}
                </div>
                <div v-else>
                    <div class="font-medium text-[10px] xs:leading-3 xs:mt-1" :class="tab.value === currentTab ? 'text-black-600' : 'text-gray-500'">{{ tab.title }}</div>
                </div>
            </div>
        </button>
    </nav>
    <nav v-else class="h-10" :class="wrapperClass">
        <button
            type="button"
            v-for="tab in tabs"
            :ref="tab.value"
            :key="tab.title"
            :class="[
                { 'bg-white rounded-t-lg': tab.value === currentTab },
                tab.value === currentTab && tabActiveClass
                    ? tabActiveClass
                    : '',
                tabClass,
            ]"
            :disabled="tab.disabled || false"
            @click="handleClick(tab.value)"
        >
            <span class="flex items-center justify-center gap-1 px-3 pt-[10px] pb-[10px] border border-white rounded-t-lg h-10" :class="itemClasses">
                <template v-if="tab.icon">
                    <fa class="text-gray-300 text-sm" :icon="['far', tab.icon]"></fa>
                </template>
                <template v-if="tab.count > 0 && type == 'AccountListTab'">
                    {{tab.count}} {{tab.title }}
                </template>
                <template v-else-if="tab.count > 0 && type != 'AccountListTab'">
                    <div class="font-medium text-sm" :class="tab.value === currentTab ? 'text-black-500' : 'text-gray-400 '">
                        {{ tab.title + ' (' + tab.count + ')' }}</div>
                </template>
                <template v-else>
                    <div class="font-medium text-sm" :class="tab.value === currentTab ? 'text-black-600' : 'text-black-600 '">{{ tab.title }}
                        <span v-if="tab.subtitle" class="block text-xs font-normal" :class="tab.value === currentTab ? 'text-black-600' : 'text-black-600 '">{{ tab.subtitle }}</span>
                    </div>
                </template>
            </span>
        </button>
    </nav>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useScreenSize } from '@/composables/globals';

const props = defineProps({
    currentTab: {
        type: String,
        required: true,
    },
    tabs: {
        type: Array,
        required: true,
    },
    updated: {
        type: [Boolean, String, Array],
        default: undefined,
    },
    wrapperClass: {
        type: String,
        default: '',
    },
    tabClass: {
        type: String,
        default: '',
    },
    tabActiveClass: {
        type: String,
        default: '',
    },
    tabButtonClass: {
        type: String,
        default: '',
    },
    lineClass: {
        type: String,
        default: '',
    },
    itemClasses:{
        type:String,
        default:'',
    },
    type: {
        type: String,
        default: '',
    },
    iconSize : {
        type: String,
        default: '',
    }
});

const activeLineWidth = ref(0);
const activeLineOffset = ref(0);
const newTab = ref('');
const refs = ref({});
const isDesktop = useScreenSize();
const emit = defineEmits(['onClick']);
const setRef = (el, tab) => {
    refs.value[tab.value] = el;
};

const moveActiveLine = (newValue) => {
    if (!props.currentTab) return;
    const element = refs.value[newValue];
    if (!element) return;
    activeLineWidth.value = element.clientWidth;
    activeLineOffset.value = element.offsetLeft;
};

const handleClick = (value) => {
    emit('onClick', value);
    moveActiveLine(value);
    newTab.value = value;
};

watch(() => props.currentTab, (newCurrentTab) => {
    if (newTab.value === newCurrentTab) return;
    moveActiveLine(newCurrentTab);
    newTab.value = newCurrentTab;
});

watch(() => props.updated, () => {
    moveActiveLine(props.currentTab);
});

onMounted(() => {
    moveActiveLine(props.currentTab);
    newTab.value = props.currentTab;
});
</script>


<style scoped>
.Accounts_tab button span div , .Accounts_list_tabs button span   {
@apply !text-gray-400; 
font-size: 14px;
font-weight: 500;
line-height: 16.94px;
text-align: left;
}
.Accounts_tab button span {
    @apply !border-0 ;
} 
.Accounts_tab {
    @apply rounded-lg bg-transparent !border !border-white;;
}
.Accounts_list_tabs{
  @apply rounded bg-gray-100;
  white-space: nowrap;
}

.Accounts_list_tabs button  span
{
  @apply bg-gray-100 !text-gray-400 border border-gray-100;
}
.Accounts_tab .default-tabs__item_active_con span  , .Accounts_list_tabs .default-tabs__item_active_con span {
    @apply bg-white; 
    border-radius:  4px !important;
}
.Accounts_tab .default-tabs__item_active_con span div , .Accounts_list_tabs .default-tabs__item_active_con span div{
    @apply !text-black-500;
}
.Accounts_tab button:nth-child(1) span ,.Accounts_list_tabs button:nth-child(1) span
{
    border-radius: 4px 0px 0px 4px;
}
.Accounts_tab button:last-child span ,.Accounts_list_tabs button:last-child span
{
    border-radius: 0px 4px 4px 0px;
}
.Accounts_tab button span{
    height:30px !important;
    padding: 10px 12px 10px 12px;
}
.Accounts_list_tabs button span{
    height:32px !important;
    padding: 10px 12px 10px 12px;
    /* border-radius:0px 4px 4px 0px;  */
}
.Accounts_tab .default-tabs__item_active_con  , .Accounts_list_tabs .default-tabs__item_active_con 
{
    border-radius :4px !important;
}
.Accounts_list_tabs .default-tabs__item_active_con span{
   @apply border border-gray-150;
}
.default-tabs__item_con {
  @apply -mr-[1px];
}

@media only screen and (max-width:900px) {
    .Accounts_tab button span div , .Accounts_list_tabs button span   {
    font-size: 12.5px;
}
}
</style>
